import { useEffect } from 'react';
import './ComunityPopup.scss';


function ComunityPopup() {
  useEffect(()=>{
    (window as any).VK.Widgets.Group("vk_groups", {mode: 1, no_cover: 1, height: 100}, 230416089);
  }, [])
    return <div id="vk_groups"></div>
};

export default ComunityPopup;